import { BaseNode } from './base/BaseNode';

export class HorizontalRule extends BaseNode {
  constructor() {
    super('horizontal_rule');
  }

  get schema() {
    return {
      group: 'block',
      parseDOM: [{ tag: 'hr' }],
      toDOM() {
        return ['hr'] as const;
      },
      leafText: () => '---',
    };
  }
}
